import React from 'react';
import { Link, Typography, Stack } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import {
	IMGUR_UPLOAD_FAILED,
	IMGUR_UPLOAD_REQUESTING,
	TEXT_IMGUR_FAILED,
	TEXT_IMGUR_REQUESTING,
} from './const';
import { copyTextToClipboard } from './UtilsDom';

export default function ImgurResult(props: { url: string }) {
	const clipboard = React.useCallback(
		() => copyTextToClipboard(props.url),
		[props.url],
	);
	if (props.url === IMGUR_UPLOAD_FAILED) {
		return (
			<Typography variant='body2' color='textSecondary'>
				{TEXT_IMGUR_FAILED}
			</Typography>
		);
	} else if (props.url === IMGUR_UPLOAD_REQUESTING) {
		return (
			<Typography variant='body2' color='textSecondary'>
				{TEXT_IMGUR_REQUESTING}
			</Typography>
		);
	}
	return (
		<Stack direction='row' spacing={1} sx={{ alignItems: 'center' }}>
			<Typography variant='body2' color='textSecondary'>
				<Link href={props.url} variant='inherit' underline='always'>
					{props.url}
				</Link>
			</Typography>
			<Tooltip title='URLをコピー' onClick={clipboard}>
				<IconButton size={'small'}>
					<ContentCopyIcon fontSize={'inherit'} />
				</IconButton>
			</Tooltip>
		</Stack>
	);
}
/*

			<Button>{props.url}</Button>
			<Tooltip title='Delete'>
				<IconButton>
					<ContentCopyIcon />
				</IconButton>
			</Tooltip>
*/
